/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex } from '@chakra-ui/react'
import { CSSProperties } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { Header, Container } from './styles'
interface iModalProps {
  Titulo?: string
  Subtitulo?: string
  Width?: string
  styleHeader?: CSSProperties
  disabledHeader?: boolean
  className?: string
  isOpen: boolean
  onClose: () => void
  colorTitulo?: string
}

export const ModalBase: React.FC<iModalProps> = ({ isOpen, colorTitulo, className, Titulo, Subtitulo, styleHeader, children, Width, disabledHeader, onClose }) => {
  return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            overlayClassName='react-modal-overlay'
            className={className ?? 'react-modal-content-scroll'}
        >
            <Container width={Width}>
                {!disabledHeader &&
                    <Header>
                        <Flex width={'100%'} flexDirection={'column'} style={styleHeader}>
                            {Titulo && <h3 style={{ color: colorTitulo || '#000', fontSize: '1.125rem', lineHeight: '1.25rem' }}>{Titulo}</h3>}
                            {Subtitulo && <span style={{ fontSize: '.813rem', lineHeight: '1rem' }}>{Subtitulo}</span>}
                        </Flex>
                        <Flex>
                            <MdClose size={20} onClick={onClose} />
                        </Flex>
                    </Header>
                }
                {children}
            </Container>
        </Modal>
  )
}
